import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ratebooklanding',
  templateUrl: './ratebooklanding.component.html',
  styleUrls: ['./ratebooklanding.component.scss'],
})
export class RatebooklandingComponent implements OnInit {

  constructor() { }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  goToDashboard() {
    window.location.href = 'https://coboticsaiapps.com/';
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();

    // your login route
    window.location.href = '/signup';
  }

}
